var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDressCodeForGentlemen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.366,4.527l1.298-4.527h-7.327l1.298,4.527-2.676,14.943,5.042,4.481,5.042-4.481-2.676-14.943Zm-.029-3.527l-.86,3h-2.952l-.86-3h4.673Zm-6.295,18.095l2.524-14.095h2.869l2.524,14.095-3.958,3.519-3.958-3.519Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressCodeForGentlemen);
export default __webpack_public_path__ + "static/media/DressCodeForGentlemen.c37102a3e50022bde3cf5b14a1dba909.svg";
export { ForwardRef as ReactComponent };